import { LogOut, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { SyncIndicator } from '@/components/feedback/SyncIndicator';
import { HostPill } from '@/components/host/HostPill';
import { useLogout } from '@/api/queries';
import { useAuth } from '@/hooks/useAuth';

export function Topbar() {
  const { user } = useAuth();
  const logout = useLogout();
  const navigate = useNavigate();

  const initials = user?.full_name
    ?.split(/\s+/)
    .map((s) => s[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <header className="flex h-14 items-center justify-between border-b bg-card/50 px-6 backdrop-blur">
      <div className="text-sm text-muted-foreground">
        {user?.full_name && (
          <>
            Signed in as <span className="text-foreground">{user.full_name}</span>
            {user.role === 'admin' && <span className="ml-2 rounded bg-primary/10 px-1.5 py-0.5 text-[10px] uppercase tracking-wider text-primary">admin</span>}
          </>
        )}
      </div>
      <div className="flex items-center gap-3">
        <SyncIndicator />
        <HostPill />
        <Link to="/profile">
          <Avatar className="h-9 w-9 transition-opacity hover:opacity-80">
            {user?.avatar_url ? <AvatarImage src={user.avatar_url} alt={user.full_name} /> : null}
            <AvatarFallback>{initials ?? <User className="h-4 w-4" />}</AvatarFallback>
          </Avatar>
        </Link>
        <Button
          variant="ghost"
          size="icon"
          title="Sign out"
          onClick={async () => {
            await logout.mutateAsync();
            navigate('/login', { replace: true });
          }}
        >
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
    </header>
  );
}
